import { loadAndAddImage } from '../image_helpers';

const labelImageId = `map-marker-label`;
const labelImageSrc = `https://cdn-assets.alltrails.com/assets/icons/maps/markers/map-marker-label@2x.png`;

const addLabelImagesToMap = map => {
  return loadAndAddImage(map, labelImageId, labelImageSrc, {
    pixelRatio: 2
  });
};

const createLabelLayer = (id, sourceId, field, filter = null) => {
  const layer = {
    id,
    type: 'symbol',
    source: sourceId,
    layout: {
      'icon-anchor': 'bottom',
      'icon-allow-overlap': true,
      'icon-ignore-placement': true,
      'icon-image': ['image', labelImageId],
      'icon-text-fit': 'both',
      'icon-text-fit-padding': [12, 24, 12, 24],
      'icon-offset': [0, 0],
      'text-field': ['get', field],
      'text-font': ['Proxima Nova Regular'],
      'text-size': 14,
      'text-offset': [0, -1.9],
      'text-anchor': 'bottom'
    }
  };
  if (filter) {
    layer.filter = filter;
  }
  return layer;
};

export { addLabelImagesToMap, createLabelLayer };
